import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/autouse/report',
    name: 'autouse',
    meta: {
      title: '月度用车报告详情',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/autoUseReport/monthAutoReportDetail.vue'),
  },
  {
    path: '/autouse/ranking',
    name: 'autoUseRanking',
    meta: {
      title: '月度用车报告排行榜',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/autoUseReport/monthAutoReportRanking.vue'),
  },
  {
    path: '/autouse/list',
    name: 'autoUseList',
    meta: {
      title: '用车报告列表',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/autoUseReport/autoUseReportList.vue'),
  },
]

export default routes
